
import Switch from '@mui/material/Switch'

import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import { toast } from 'react-toastify'

import {
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  QueriesCtx,
} from '.'

/*
 * ImportListModal
**/
const ImportListModal = (props) => {
  // logg(props, 'ImportListModal')

  /* ctx */

  const apiRouter = useApiRouter()

  const {
    loading, setLoading,
  } = useContext(AppCtx)

  const {
    importListModalOpen, setImportListModalOpen,
    refreshQueriesList,
  } = useContext(QueriesCtx)

  /* state */

  const [ file, setFile ] = useState(false)
  const [ isCertOrRssd, setIsCertOrRssd ] = useState(false)
  const [ name, setName ] = useState('')

  /* methods */

  const clear = () => {
    setFile(false)
    setIsCertOrRssd(false)
    setName('')
    setImportListModalOpen(false) // b/c otherwise, the file input doesn't clear.
  }

  const handleClose = () => {
    clear()
    setImportListModalOpen(false)
  }

  const handleSubmit = (ev) => {
    ev.preventDefault()
    setLoading(true)

    const formData = new FormData()
    formData.append('file', file)
    formData.append('fileName', file.name)
    formData.append('list[name]', name)
    formData.append('is_cert_or_rssd', isCertOrRssd)
    fetch(apiRouter.listImportPath(), {
      method: 'POST',
      headers: {
        // 'content-type': 'multipart/form-data', // 2024-12-26 specifically remove the content-type.
      },
      body: formData,
    }).then(r => {
      if (!r.ok) { throw r }
      return r.json()
    }).then(inns => {
      logg(inns, 'imported new list')
      refreshQueriesList()
      setImportListModalOpen(false)
      toast('Imported new list.')
      inns.messages.forEach((msg) => toast(msg))
    }).catch((err) => {
      logg(err, 'err')
      err.text().then((body) => {
        logg(body, 'body')
        JSON.parse(body).messages.forEach((msg) => toast(msg))
      })
    }).finally(() => {
      clear()
      setLoading(false)
    })
  }

  return <Modal
      ariaHideApp={false}
      className="ImportListModal BaseModal DoL"
      isOpen={importListModalOpen}
      onRequestClose={handleClose}
      overlayClassName="ImportListModalOverlay"
    >
      <form method='POST' onSubmit={handleSubmit} >
        <div className='header'>
          <h5 >Import a List</h5>
          <div className='close' onClick={() => setImportListModalOpen(false)}>&times;</div>
        </div>
        <div className='modal-body p-2'>
          <p>Please select whether you're importing by rssd or by cert, and upload a csv file with one rssd (or cert) per row. The header is optional.</p>

          <p className='center'>
            <label>Rssd</label>
            <Switch
              checked={isCertOrRssd}
              onChange={(ev) => setIsCertOrRssd(!isCertOrRssd) }
            />
            <label>Cert</label>
          </p>

          <div className='mt-3 mb-3'>
            <input type='file' name='theImport' required={true}
              onChange={(ev) => setFile(ev.target.files[0])} />
          </div>

          <div className='name-row d-flex w-100 mb-3' >
            <label>Name&nbsp;</label>
            <input type='text' required={true}
              className='flex-grow'
              onChange={(ev) => setName(ev.target.value)} value={name} />
          </div>

        </div>
        <div className='actions'>
          <div className='left'></div>
          <div className='right'>
            <button type='submit' className='Btn btn-primary' >Import</button>
          </div>
        </div>
      </form>
    </Modal>
}
export default ImportListModal

